import { ControlWidth } from 'app/components/Controls/WrappedControlProps';
import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

type FitLabelToInputConfig = { [key in ControlWidth]: number };

const maxLengthOfLabelToFitInput: FitLabelToInputConfig = {
  xs: 13,
  sm: 19,
  md: 28,
  lg: 52,
  xl: 78,
  full: 120,
};

const maxLengthOfLabelToFitInputForMobile: FitLabelToInputConfig = {
  xs: 13,
  sm: 19,
  md: 27,
  lg: 27,
  xl: 27,
  full: 27,
};

const getMaxLength = (width: ControlWidth) => {
  return isMobileOrTablet()
    ? maxLengthOfLabelToFitInputForMobile[width]
    : maxLengthOfLabelToFitInput[width];
};

export default function isLabelFitToInput(
  label: string | undefined,
  width: ControlWidth | undefined
): boolean {
  return !!label && label.length < getMaxLength(width || 'md');
}
